/**
 * Escapes special Lucene/Azure Search syntax characters in a user-supplied string
 * to prevent malformed queries or unintended query behaviour.
 *
 * Special characters: + - ! ( ) { } [ ] ^ " ~ * ? : / \ && ||
 */
export function escapeLucene(value: string): string {
  return value.replace(/([+\-!(){}[\]^"~*?:\\/]|&&|\|\|)/g, '\\$1')
}
